import React from "react";

// Source
import ControllerLocalization from "../controller/Localization";
import ViewLoader from "./Loader";

let isRendered = false;

const viewPage404: React.FC = () => {
    // Variable
    const controllerLocalization = new ControllerLocalization(isRendered);

    // Method
    controllerLocalization.initializeHook();

    // Render
    isRendered = true;

    if (controllerLocalization.getStorageMain) {
        return (
            <div className="view_not_found">
                <div>
                    <p>404</p>
                </div>
            </div>
        );
    } else {
        return <ViewLoader />;
    }
};

export default viewPage404;
